module.exports = __webpack_public_path__ + "media/images/number_1_green-d4f801697cfc684dd04bc4ea9678b570.png";